module.exports = __webpack_public_path__ + "static/media/sidebar-4.fc9cb053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-4.jpg
// module id = 762
// module chunks = 0